import { getQuoteForm, getPremiumCalculationUg } from '../../../selectors/ugMotorInsurance/quote';
import { getIsApiPending } from '../../../selectors/ugMotorInsurance/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/ugMotorInsurance/payloadCollection';
import { getAgentForm } from '../../../selectors/ugMotorInsurance/travelAgentModal';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import {
    setCustomerIdValue,
    setInsuranceQuotationId,
    setVehicleRecordId,
} from '../../../actions/ugMotorInsurance/quote';

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

export const submitQuoteDetailsService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                let resp;

                resp = await makeSubmission(store.getState());

                if (resp.data) {
                    store.dispatch(setCustomerIdValue(resp.data.data.id));
                    store.dispatch(setVehicleRecordId(resp.data.data.vehicles[0].id));
                    store.dispatch(setInsuranceQuotationId(resp.data.data.quotations[0].id));

                    store.dispatch(apiTransitionPayloadCollection.initial());
                }
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionPayloadCollection.initial());
            }
        }
    })();
    return next(action);
};

const getFullName = (quotation) => {
    const firstName = quotation.firstName?.value || '';
    const middleName = quotation.middleName?.value || '';
    const lastName = quotation.lastName?.value || '';

    return [firstName, middleName, lastName].filter(Boolean).join(' ');
};

const payloadCollection = (state) => {
    const quotation = getQuoteForm(state);
    const agent = getAgentForm(state);
    const premium = getPremiumCalculationUg(state);

    const premiumCalculationPayload = {
        countryCode: gatsbyStack.toUpperCase(),
        make: parseInt(quotation.carMake.value.id) || parseInt(quotation.carModel.value.id),
        model: parseInt(quotation.carModel.value.id),
        yearOfManufacture: quotation.yearOfManufacture.value,
        carValue: quotation.valuation.value || 0,
        violenceAndTerrorismCovered: quotation.violenceAndTerrorism.value,
        uncommonRisksCovered: quotation.uncommonRisk.value,
        excessProtectorOption: quotation.excessProtector.value,
        use: quotation.carUse.value,
        valuationDone: quotation.isCarValued.value === 'yes' ? true : false,
        alarmInstalled: quotation.hasAlarm.value === 'yes' ? true : false,
        annualPremium: premium.value.premium || premium.value.totalPremium,
        basePremiumRate: premium.value.basePremiumRate || 0,
        valuedBy: quotation.carValuer.value || 'N/A',
        coverStartDate: quotation.coverStartDate.value,
        excessProtectorFees: premium.value.excessProtectorFees || 0,
        uncommonRisksCoveredFees: premium.value.uncommonRisksCoveredFees || 0,
        violenceAndTerrorismFees: premium.value.violenceAndTerrorismFees || 0,
        trainingLevies: premium.value.trainingLevy || 0,
        vatCharge: premium.value.vatCharge || 0,
        fullName: getFullName(quotation),
        withinUG: quotation.outsideEa.value === 'within-ug' ? true : false,
        withinEA: quotation.outsideEa.value === 'within-ea' ? true : false,
        outsideEA: quotation.outsideEa.value === 'outside-ea' ? true : false,
    };

    const agentPayload = {
        agentCode: agent.agentCode?.value || 'N/A',
        agentName: agent.name?.value?.value || 'N/A',
        referredByAgent: agent.name?.value ? true : false,
        agentType: agent.intermediaryType?.value || 'N/A',
    };

    const regionMap = {
        'within-ea': 2,
        'outside-ea': 3,
    };

    let region = regionMap[quotation.outsideEa.value] || 1;

    const additionalFields = {
        alternativeAccomodation: quotation.alternativeAccomodation.value
            ? parseInt(quotation.alternativeAccomodationDays.value)
            : 0,
        firstApplication: quotation.firstTimePurchase.value === 'yes',
        carHire: quotation.carHire.value ? parseInt(quotation.carHireDays.value) : 0,
        carAlarmDiscount: quotation.hasAlarm.value === 'yes',
        trackerDiscount: quotation.trackingSystem.value === 'yes',
        pvt: quotation.violenceAndTerrorism.value ? quotation.violenceAndTerrorism.value : false,
        region,
        excessValue: quotation.excessAmount.value ? parseInt(quotation.excessAmount.value) : 0,
        trackerInstalled: quotation.trackingSystem.value === 'yes',
    };

    return {
        ...premiumCalculationPayload,
        ...agentPayload,
        ...additionalFields,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ug-motor-insurance/submit/quote';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
